import { createAsyncThunk } from "@reduxjs/toolkit";
import { formatDate, updateDefaultDateTime } from "@euroland/libs/utils/formatDate";

import { getTickers } from "../services";
import { companySettingsSelector } from "../store/slice/settings";
import { flattenObjectValues } from "../utils";
import { stockSnapshotSelector, stockTradesSelector } from "../store/slice/realtime";
import { calculateMarketData, mergeRealtimeMarketData, mergeStockData } from '../utils/marketData';
import { instrumentSelector } from "../store/slice/instrument";
import { trimAbbreviation } from "../utils/index";

export const getTickersAction = createAsyncThunk("trade/tickers", async ({ toCurrency = null, adjClose = false }, { getState }) => {
  const settings = companySettingsSelector(getState());
  const tickers = await getTickers(toCurrency, adjClose);
  const stockSnapshot = stockSnapshotSelector(getState());
  const stockTrades = stockTradesSelector(getState());
  const latestRealTimeData = mergeStockData(stockSnapshot, stockTrades);

  tickers.data.instruments = tickers.data.instruments.map(item =>
    flattenObjectValues(item)
  ).sort((a, b) => {
    return a.order - b.order;
  });
  // replace custom field from settings
  tickers.data.instruments = tickers.data.instruments.map(item => {
    // replace custom field from settings
    const instrumentSetting = settings.instruments.find(({ id }) => item.instrumentId === id);
    let itemSetting = instrumentSetting;
    item.shareName = trimAbbreviation(item.shareName);

    if (instrumentSetting) {
      item.ticker = instrumentSetting.ticker || item.ticker;
      item.currencyCode = instrumentSetting.currencyCode || item.currencyCode;
      item.marketName = instrumentSetting.marketName || item.marketName;
      item.shareName = instrumentSetting.shareName || item.shareName;
      item.marketAbbreviation = instrumentSetting.marketAbbreviation || item.marketAbbreviation;
      item.order = itemSetting.order === null ? 0 : itemSetting.order;
      item.isRT = instrumentSetting.isRT ?? false;
      item.industry = instrumentSetting.industry || item.industry;
    }
    // merge with realtime data
    if (latestRealTimeData[item.instrumentId] && (item.marketStatus === true || item.marketStatus === 'Open')) {
      item = mergeRealtimeMarketData(item, latestRealTimeData[item.instrumentId]);
    }
    // calculate changed fields using utility
    item = calculateMarketData(item, { usePrevCloseDayForMcap: settings.usePrevCloseDayForMcap });

    return item;
  });

  return tickers;
});

export const updateStockData = createAsyncThunk(
  "instrument/UpdateStockData",
  async ({ instrumentId, data }, { getState }) => {
    let updateData = {
      id: instrumentId,
      data: {},
    }
    const { instruments, selectedInstrumentId } = instrumentSelector(getState());
    const instrumentData = instruments.find(inst => inst.instrumentId === instrumentId);
    if (instrumentData.marketStatus === 'Close') {
      return Promise.resolve(updateData);
    }
    const settings = companySettingsSelector(getState());
    const instrumentCustomTimeZone = settings.instruments.find(inst => inst.id === instrumentId)?.customTimezone;
    updateDefaultDateTime({ timezone: instrumentData?.marketTimeZoneNameIANA || instrumentCustomTimeZone || settings?.timeZone });
    const currentTime = formatDate(instrumentData.lastUpdatedDate, "HH:mm:ss");
    const selectedInstrumentData = instruments.find(inst => inst.instrumentId === selectedInstrumentId);
    const selectedInstrumentTimeZone = settings.instruments.find(inst => inst.id === selectedInstrumentId)?.customTimezone;
    updateDefaultDateTime({ timezone: selectedInstrumentTimeZone || selectedInstrumentData?.marketTimeZoneNameIANA || settings?.timeZone });
    if (currentTime < instrumentData?.openTimeLocal || currentTime > instrumentData?.closeTimeLocal) {
      return Promise.resolve(updateData);;
    }
    updateData.data = structuredClone(data);

    for (const key of Object.keys(updateData.data)) {
      if (updateData.data[key] == null) delete updateData.data[key];
    }

    return Promise.resolve(updateData);;
  },
);
